import Vue from 'vue'

/* Plugins for the Vue app */
import './plugins/toasted'
import './plugins/vuetify'
import './plugins/vuex'
import './plugins/notifications'
import router from './router'
import store from './store'

/* Principal App component */
import App from './App.vue'

/* Global components */
import JsonExcel from "vue-json-excel";
import BaseButton from './components/BaseButton'
import BaseSelect from './components/BaseSelect'

Vue.config.productionTip = false
Vue.component('base-button', BaseButton)
Vue.component('base-select', BaseSelect)
Vue.component("downloadExcel", JsonExcel);


new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
